import classNames from 'classnames';
import React, { PureComponent } from 'react';
import type { Merge } from 'types/utility';
import styles from './index.module.scss';

interface ListProps {
  children: React.ReactNode;
  className?: string | null | undefined;
}
export class List extends React.Component<ListProps> {
  render() {
    const { children, className, ...rest } = this.props;
    const containerClass = classNames(styles.list, className);

    const containerProps = {
      ...rest,
      className: containerClass,
    };

    return <div {...containerProps}>{children}</div>;
  }
}

interface ListRowOwnProps {
  children: React.ReactNode;
  className?: string | null | undefined;
  size?: null | 'small' | 'medium' | 'large';
}
type ListRowProps = Merge<React.HTMLProps<HTMLDivElement>, ListRowOwnProps>;
export class ListRow extends PureComponent<ListRowProps> {
  render() {
    const { children, className, size, ...rest } = this.props;
    const containerClass = classNames(
      styles.listRow,
      className,
      styles[`size-${size || 'medium'}`]
    );
    return (
      <div {...rest} className={containerClass}>
        {children}
      </div>
    );
  }
}

interface ListColumnProps extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode;
  autoGrow?: boolean | null | undefined;
  headlineLink?: boolean | null | undefined;
}
export const ListColumn = (props: ListColumnProps) => {
  const { children, className, autoGrow, headlineLink, ...rest } = props;
  const containerClass = classNames(styles.listCol, className, {
    [styles.autoGrow]: autoGrow, // @todo: this should be reversed from current usage
    [styles.headlineLink]: headlineLink,
  });
  return (
    <div {...rest} className={containerClass}>
      {children}
    </div>
  );
};
